<div class="confirm-password-reset">
  <div class="confirm-password-reset-form wm-view">
    <div class="wm-topbar">
      <div class="wm-topbar-header">Change Password</div>
    </div>
    <div class="wm-card confirm-password-reset-container">
      @if (!requestSuccess) {
        <div [hidden]="requesting">
          <div class="confirm-password-reset-instruction">Enter your new password and retype it for verification.</div>
          <div class="wm-card-content">
            <div class="form-item confirm-password-reset-input-container">
              <div class="form-label">
                Password
              </div>
              <input pInputText [autofocus]="true" type="password" [(ngModel)]="password" tabindex="1" data-testing-id="confirm-password-reset-passwordfield">
            </div>
            <div class="form-item confirm-password-reset-input-container">
              <div class="form-label">
                Repeat Password
              </div>
              <input pInputText type="password" [(ngModel)]="repeatPassword" tabindex="2" data-testing-id="confirm-password-reset-passwordrepeatfield">
              @if (password !== repeatPassword) {
                <div class="confirm-password-reset-errormessage" data-testing-id="confirm-password-reset-nomatcherror">Passwords do not match!</div>
              }
              @if (!resetTokenValid) {
                <div class="confirm-password-reset-errormessage">Reset Token is invalid!</div>
              }
              @if (error) {
                <div class="confirm-password-reset-errormessage" data-testing-id="confirm-password-reset-apierror">
                  {{error | errorMsg | async}}
                </div>
              }
            </div>
            <button pButton [disabled]="!valid()" class="confirm-password-reset-submitbutton" (click)="confirmResetPassword()" data-testing-id="confirm-password-reset-submit-button">Change Password</button>
          </div>
        </div>
      }
      @if (requestSuccess) {
        <div>
          <div class="confirm-password-reset-success">
            <div class="msg">Successfully changed your password</div>
            <button pButton  label="Back To Login" routerLink="/login" data-testing-id="confirm-password-reset-login-link"></button>
          </div>
          @if (requesting) {
            <div class="loading-spinner">
              <p-progressSpinner></p-progressSpinner>
              <div>Resetting Your Password...</div>
            </div>
          }
        </div>
      }
    </div>
